import Axios from "axios";

export const useReportIframe = ({ search, searchByValue }) => {
  const encryptMemberId = async (encodeString) => {
    const innoOrg = Buffer.from(
      `${process.env.REACT_APP_AMERICAN_COLLECTIVE};${new Date()}`,
    ).toString("base64");

    const res = await Axios.post(
      `${process.env.REACT_APP_BASE_URL}v1/csrportal/idencryption`,
      { memberId: encodeString },
      {
        headers: {
          "X-Tenant-Id": innoOrg,
          Authorization: `Bearer ${localStorage.getItem("innobearerToken")}`,
        },
      },
    );

    return encodeURIComponent(res.data);
  };

  const buildIframeURL = async (reportPath, searchVal, searchByVal) => {
    const request = `memberid=&adminEmail=${localStorage.getItem(
      "email",
    )}&type=${searchByVal}&searchBy=${searchVal}`;

    const query = await encryptMemberId(request);
    const token = localStorage.getItem("innobearerToken");

    return (
      `http://localhost:3000/` + `${reportPath}?query=${query}&token=${token}`
    );
  };

  const triggerDownload = () => {
    const iframe = document.getElementById("report-iframe");
    if (!iframe) return;

    iframe.contentWindow.postMessage({ type: "DOWNLOAD_REPORT" }, "*");
  };

  return {
    buildIframeURL,
    triggerDownload,
  };
};
